<script setup lang="ts">
import type { Dictionary } from '@autobid/strapi-integration/typescript/webapi/Dictionary'
import { useFormItem } from '@autobid/nuxt-pinia-store/store/searchStore/useFormItem'
import Checkbox from '@autobid/ui/components/elements/checkbox/Checkbox.vue'

interface Props {
  item: Dictionary
}

const props = defineProps<Props>()
const checked = useFormItem({ key: props.item.structureId })
</script>

<template>
  <Checkbox
    :checked="Boolean(checked)"
    :label="item.label"
    :label-props="{ class: 'text-ellipsis overflow-hidden', title: item.label }"
    @change="() => (checked = !checked as unknown as typeof checked)"
  />
</template>
